import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { MagnifyingGlass, ArrowSquareOut } from "@phosphor-icons/react";

export default function InpiMonitoring() {
  const [q, setQ] = useState("");
  const [classe, setClasse] = useState("");
  const [items, setItems] = useState([]);
  const [note, setNote] = useState("");

  const load = async () => {
    const { data } = await api.get("/inpi/search", { params: { q, classe: classe || undefined } });
    setItems(data.items);
    setNote(data.note);
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="inpi-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-2">Monitoramento INPI</div>
        <h1 className="font-heading font-extrabold text-4xl">Pesquisa de marcas — INPI</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-2xl">
          Consulta de pedidos e registros de marca. Suporta busca por nome exato, radical e variações ortográficas.
        </p>
      </div>

      <div className="p-4 border-l-4 border-[#B45309] bg-[#FFF7ED] rounded-sm" data-testid="inpi-notice">
        <div className="font-heading font-bold text-sm text-[#B45309]">Monitoramento automático do INPI em desenvolvimento</div>
        <div className="text-sm text-[#7C2D12] mt-1">
          Nesta versão, a consulta pode ser realizada por cadastro/importação assistida. A integração automática com a base pública do INPI está prevista para a próxima versão.
        </div>
      </div>

      <Card className="p-4 rounded-sm border">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_auto] gap-3 items-end">
          <div>
            <Label className="text-xs uppercase">Nome / Radical</Label>
            <Input data-testid="inpi-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ex: Confidence" className="rounded-sm" />
          </div>
          <div>
            <Label className="text-xs uppercase">Classe</Label>
            <Select value={classe || "all"} onValueChange={(v) => setClasse(v === "all" ? "" : v)}>
              <SelectTrigger className="rounded-sm"><SelectValue placeholder="Todas" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Todas</SelectItem>
                <SelectItem value="35">35 — Serviços de negócios</SelectItem>
                <SelectItem value="36">36 — Financeiro</SelectItem>
                <SelectItem value="41">41 — Educação</SelectItem>
                <SelectItem value="45">45 — Jurídicos</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <Button data-testid="inpi-search-btn" onClick={load} className="rounded-sm bg-[#0A3B2C] hover:bg-[#083527]"><MagnifyingGlass size={16} className="mr-2" /> Buscar</Button>
        </div>
        {note && <div className="mt-3 p-2 bg-[#F3F4F6] border-l-4 border-[#B45309] text-xs">{note}</div>}
      </Card>

      <Card className="rounded-sm border overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-[#F9FAFB]">
              <TableHead className="text-[10px] uppercase">Nº Processo</TableHead>
              <TableHead className="text-[10px] uppercase">Nome</TableHead>
              <TableHead className="text-[10px] uppercase">Titular</TableHead>
              <TableHead className="text-[10px] uppercase">Classe</TableHead>
              <TableHead className="text-[10px] uppercase">Apresentação</TableHead>
              <TableHead className="text-[10px] uppercase">Situação</TableHead>
              <TableHead className="text-[10px] uppercase">Data depósito</TableHead>
              <TableHead className="text-[10px] uppercase text-right">Fonte</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((r) => (
              <TableRow key={r.id} data-testid={`inpi-row-${r.id}`} className="hover:bg-muted/40">
                <TableCell className="text-xs font-mono">{r.inpi_data?.numero_processo}</TableCell>
                <TableCell className="text-sm font-semibold">{r.nome_encontrado}</TableCell>
                <TableCell className="text-xs">{r.inpi_data?.titular}</TableCell>
                <TableCell><Badge variant="outline" className="rounded-sm text-xs">{r.inpi_data?.classe}</Badge></TableCell>
                <TableCell className="text-xs">{r.inpi_data?.apresentacao}</TableCell>
                <TableCell className="text-xs">{r.inpi_data?.situacao}</TableCell>
                <TableCell className="text-xs font-mono">{r.inpi_data?.data_deposito}</TableCell>
                <TableCell className="text-right"><a href={r.inpi_data?.link_fonte} target="_blank" rel="noreferrer" className="text-[#0A3B2C] inline-flex items-center gap-1 text-xs"><ArrowSquareOut size={12} /></a></TableCell>
              </TableRow>
            ))}
            {!items.length && <TableRow><TableCell colSpan={8} className="text-center py-6 text-sm text-muted-foreground">Nenhum registro INPI. Execute uma varredura com fonte "INPI".</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
